document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.mtt-faq-accordion')
    const activeClass = 'mtt-faq-accordion--active'

    if (accordions.length > 0) {
        for (let i = 0; i < accordions.length; i++) {
            const CONTENT = accordions[i].querySelector('.mtt-faq-accordion__content')
            const HEIGHT = CONTENT.offsetHeight
            CONTENT.setAttribute('data-height', HEIGHT)
            CONTENT.style.height = '0px'
            const TITLE = accordions[i].querySelector('.mtt-faq-accordion__title')
            TITLE.addEventListener('click', () => {
                const accordionElement = accordions[i]
                const isActive = accordionElement.classList.toggle(activeClass)
                TITLE.setAttribute('aria-expanded', isActive)
                if(isActive){
                    CONTENT.style.height = HEIGHT + 'px'
                }else {
                    CONTENT.style.height = '0px'
                }
            })
        }
    }
});
